import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, inject } from '@angular/core';
import { ButtonComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { Balance, Debt } from 'mbs-ui-shared@components/components/models/license.model';
import { BALANCE_TOKEN } from 'mbs-ui-shared@components/licenses/tokens/balance.token';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { LicensesService } from 'mbs-ui-shared@services/licenses.service';
import { Observable, map, take } from 'rxjs';

import { AsyncPipe, CommonModule } from '@angular/common';

import { I18NextPipe } from 'angular-i18next';
@Component({
  selector: 'mbs-payment-debt-modal',
  templateUrl: './payment-debt-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, ButtonComponent, CommonModule, I18NextPipe, ModalComponent, ModalFooterDirective]
})
export class PaymentDebtModalComponent implements OnInit {
  auth = inject(AuthFacade);
  private licenseService = inject(LicensesService);
  private cdr = inject(ChangeDetectorRef);
  balance = inject<Observable<Balance>>(BALANCE_TOKEN);

  public userId = this.auth.currentUser$.pipe(map((user) => user.Id));

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public debt: Debt = null;
  public loading = true;
  public payLinkLoading = false;

  ngOnInit() {
    this.setDebt();
  }

  goToPay() {
    this.payLinkLoading = true;

    this.licenseService
      .getPayDebt()
      .pipe(take(1))
      .subscribe((payDebt) => {
        this.payLinkLoading = false;
        this.cdr.detectChanges();
        window.open(payDebt.paymentLink, '_blank');
      });
  }

  setDebt() {
    this.loading = true;

    this.licenseService
      .getDebt()
      .pipe(take(1))
      .subscribe((debt) => {
        this.debt = debt;
        this.loading = false;
        this.cdr.detectChanges();
      });
  }
}
